import React from 'react';
import styles from './index.module.less';
interface Props {
  category: any;
}

const CategoryName: React.FC<Props> = (props: Props) => {
  const { category } = props;

  return (
    <div className={styles.categoryItem}>
      <div className={styles.categoryName}>
        <span className={styles.title}>{category.title}</span>
        <span className={styles.count} title={category.count}>
          {category.count}
        </span>
      </div>
    </div>
  );
};

export default React.memo(CategoryName);
